import React from 'react';
import { Skeleton } from '../';

export const SKELETON_WIDTH = { small: 48, medium: 64, large: 96 };

export const ValueSkeleton = ({ width = SKELETON_WIDTH.medium, className = '' }) => (
    <Skeleton.Input active size="small" className={className} style={{ width, minWidth: width }} />
);

export const LoadableValue = ({ isLoading, width, className = '', children }) =>
    isLoading ? <ValueSkeleton width={width} className={className} /> : (children ?? null);

// On click events do not have a disabled prop in the way that buttons do. Instead of passing the handler,
// we pass undefined, which prevents the event from being called.
export const disabledWhileLoading = (disabled, action) => (disabled ? undefined : action);

// Hook to determine if the card is loading or not. Checks both isLoading and isError from the query state.
// Returns loading, isError, and disabled. Disabled is true if loading or isError is true.
export const useCardLoadingState = (queryState) => {
    const { isLoading = false, isError = false } = queryState ?? {};
    const loading = isLoading && !isError;
    return { loading, isError, disabled: loading || isError };
};

export const skeletonRows = (count) => Array.from({ length: count }, () => ({}));
